// API base configuration
import { authFetch } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
const SETTINGS_ENDPOINT = `${API_BASE_URL}/settings`;

/**
 * Fetch user settings from the backend
 * @returns {Promise<Object>} The user settings
 */
export const fetchSettings = async () => {
  try {
    const response = await authFetch("/api/settings");
    
    if (!response.ok) {
      throw new Error(`Error fetching settings: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

/**
 * Save user settings to the backend
 * @param {Object} settings - The settings to save
 * @returns {Promise<Object>} The saved settings
 * 
 * The settings object includes:
 * - selectedModel: The selected AI model
 * - theme: UI theme (light/dark)
 * - responseConfig: Response configuration preferences
 * - userProfile: User profile information
 * - customPrompts: Array of saved custom prompts
 * - dataSources: Configuration for enabled data sources
 */
export const saveSettings = async (settings) => {
  try {
    const response = await authFetch(SETTINGS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    });
    
    if (!response.ok) {
      throw new Error(`Error saving settings: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error saving settings:', error);
    throw error;
  }
};

export default {
  fetchSettings,
  saveSettings
}; 